import { type HTMLArkProps, ark } from '@ark-ui/react';

import type { Scale9 } from '../../lib/types';
import { cn } from '../../lib/utils';

type HeadingElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

type HeadingProps = Omit<HTMLArkProps<'h1'>, 'color'> & {
	size?: Scale9;
	weight?: 'regular' | 'medium' | 'semibold' | 'bold';
	as?: HeadingElement;
};

function Heading({
	className,
	size = '4',
	weight = 'semibold',
	as: Tag = 'h2',
	...props
}: HeadingProps) {
	const Component = ark[Tag] as typeof ark.h1;

	return (
		<Component
			data-slot="heading"
			data-size={size}
			data-weight={weight}
			className={cn('pt-heading', className)}
			{...props}
		/>
	);
}

export { Heading, type HeadingProps };
